module.exports = __webpack_public_path__ + "img/5.abfa55da.webp";